export default "__VITE_ASSET__DL05PorH__"